<template>
  <div class="touristType">
    <h1 class="tourist-type-title">请选择游客类型</h1>
    <div class="tourist-type">
      <div class="tourist-type-upper">
        <div class="individual-guest" :class="{ currentType: touristtype === 0 }" @click="changeTouristType(0)">
          <span>{{ ticketWindow.policyGuaranteeTicketlistWindowList[0].mapName }}</span>
          <div class="current-logo-box">
            <img src="~@/assets/image/common/common_select.png" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "touristType",
  data(){
    return {
      touristtype: 0,
    }
  },
  created(){
    this.touristtype = Number(this.$route.params.touristtype);
  },
  methods: {
    async changeTouristType(index){
      this.$emit('changeTicketType', index);
      this.currentTypeList = this.$store.state.ticketWindow.policyGuaranteeTicketlistWindowList;
      const path = `/policyGuaranteeticketlist/${index}/0`;
      if(this.$route.path === path)return;
      this.$router.push(path);
      this.touristtype = index;
      this.currentTouristTypeIndex = 0;
    },
  },
  computed: {
    ...mapState(['ticketWindow'])
  },
};
</script>

<style scoped lang='less'>
.touristType {
  padding: .36rem .266667rem .453333rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  margin: 0 .266667rem;
  border-radius: .506667rem;
  & > h1{
    font-size: .4rem;
    font-weight: bold;
    color: #333333;
    line-height: .56rem;
  };
  .tourist-type{
    
    text-align: center;
    font-size: .4rem;
    margin-top: .266667rem;
    color: #333333;
    .tourist-type-upper{
      display: flex;
      &:first-child{
        margin-bottom: 0.266667rem;
      }
      .individual-guest{
        box-shadow: 0 .053333rem .106667rem .026667rem rgba(193, 60, 48, 0.04);
        border-radius: .213333rem;
        border: 1px solid #F5F5F5;
        flex: 1;
        border-radius: .213333rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.493333rem;
        .individual-guest-special{
          // font-size: ;
          line-height: 1.2;
          .text-en{
            font-size: .24rem;
            margin-top: .2rem;
          }
        }
      }
      .guide-group{
        box-shadow: 0 .053333rem .106667rem .026667rem rgba(193, 60, 48, 0.04);
        border-radius: .213333rem;
        flex: 1;
        border: 1px solid #F5F5F5;
        margin-left: .333333rem;
        height: 1.493333rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .individual-guest-special{
          // font-size: ;
          line-height: 1.2;
          .text-en{
            font-size: .24rem;
            margin-top: .2rem;
          }
        }
      }
    }
    .tourist-type-lower{
      margin-top: .266667rem;
      display: flex;
      height: 1.493333rem;
      flex-direction: column;
      box-shadow: 0 .053333rem .106667rem .026667rem rgba(193, 60, 48, 0.04);
      border-radius: .213333rem;
      border: 1px solid #F5F5F5;
      justify-content: center;
    }
    .current-logo-box{
      display: none;
    }
    .currentType{
      background: rgba(237, 192, 132, 0.35);
      border: 1px solid #9D6C29 !important;
      color: #9D6C29 !important;
      position: relative;
      .current-logo-box{
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: -0.026667rem;
        width: 0.346667rem;
        height: 0.346667rem;
        bottom: -0.026667rem;
        border: 1px solid #9D6C29;
        border-radius: .066667rem .066667rem .16rem .066667rem;
        img{
          width: 0.346667rem;
          height: 0.346667rem;
        }
      }
    }
  }
}
</style>
  